export const formatPrice = (price: number): string =>
  Number.isInteger(price) ? `$${price}` : `$${price.toFixed(2)}`;
